import {IoPeopleOutline, IoRestaurantOutline} from "react-icons/io5";
import React from "react";
import {useNavigate} from "react-router-dom";
import MeetingStatusIndicator from "./MeetingStatusIndicator";

const ChatRoomInfoContainer = ({meetingId, chatRoomInfo}) => {
    const navigate = useNavigate();

    return (
        <div className="px-4 py-3">
            <div
                onClick={() => navigate(`/app/meetings/${meetingId}`, {state: {fromChat: true}})}
                className="bg-white rounded-lg p-3 cursor-pointer active:bg-gray-50 transition-colors border border-gray-200 shadow-sm"
            >
                <div className="flex items-center">
                    {/* 모임 이미지 */}
                    <div className="mr-3 flex-shrink-0">
                        {chatRoomInfo.meetingImageUrl ? (
                            <img
                                src={chatRoomInfo.meetingImageUrl}
                                alt={chatRoomInfo.meetingTitle}
                                className="w-12 h-12 rounded-lg object-cover"
                            />
                        ) : (
                            <div className="w-12 h-12 rounded-lg bg-gray-300 flex items-center justify-center">
                                <IoRestaurantOutline size={20} className="text-gray-600"/>
                            </div>
                        )}
                    </div>

                    {/* 모임 정보 */}
                    <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-semibold text-gray-900 truncate mb-1">
                            {chatRoomInfo.meetingTitle}

                        </h3>
                        <div className="flex items-center text-xs text-gray-500">
                            <IoPeopleOutline size={12} className="mr-1"/>
                            <span>{chatRoomInfo.members?.length || 0}명 참여중</span>
                        </div>
                    </div>

                    <MeetingStatusIndicator status={chatRoomInfo.meetingStatus} />

                    {/* 화살표 아이콘 */}
                    <div className="text-gray-400">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChatRoomInfoContainer;
